import { QUERIES } from '@repo/ui/queries';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexColumn, FlexContainer } from 'styles/layouts';

import { Size, Variant } from './types';

export const Tile = styled(FlexColumn)<{ size: Size }>`
  gap: var(--spacing-8);

  ${QUERIES.largeTabletAndUp} {
    gap: ${({ size }) =>
      size === 's' ? 'var(--spacing-8)' : 'var(--spacing-12)'};
  }
`;

export const ImageWrapper = styled(FlexContainer)<{
  variant: Variant;
  backgroundColor?: string;
}>`
  position: relative;
  width: 100%;
  aspect-ratio: ${({ variant }) => (variant === 'default' ? '4/3' : '1/1')};

  overflow: hidden;

  border-radius: ${({ variant }) => (variant === 'default' ? '20px' : '12px')};
  border: 1px solid ${themeStyle.varTransparentMain5};

  justify-content: flex-end;
  align-items: flex-start;

  background-color: ${({ backgroundColor }) => backgroundColor};
`;

export const ButtonWrapper = styled.div`
  position: absolute;
  padding: 8px;
`;
